module.exports = __webpack_public_path__ + "img/misja-brief@tab.1f008b2d.png";